<template>
  <div class="basic register-entrance">
    <div class="basic-header">
      <p>- 展位预定信息 -</p>
    </div>
    <div class="top-title2 s-noline">
      <div class="line"></div>
      预订您的展位 / Book your booth<span>*</span>
    </div>
    <div class="choice">
      <div class="select-box">
        <div class="select-content" style="padding:0;">
          <div class="top">
            <div class="top-title">我想参加广州国际分析测试及实验室设备展览会暨技术研讨会请为我预定：
            <p>I want to participate in chinalab. Please make a reservation for me</p>
            </div>
            <RadioGroup v-model="areaType" @on-change="change1">
              <div class="top-item">
                <div class="top-txt">标准展位<span class="top-txt2">（1个起订）</span>/Standard booth<span class="top-txt2">(MOQ: one booth)</span>
                  <!-- <span class="top-txt2">（1个起订）</span> -->
                </div>
                <div>
                  <Radio label="标摊"></Radio>
                  <InputNumber :max="9999" :min="1" v-model="hallCount" :disabled="areaType !== '标摊'" style="width:140px;"></InputNumber>
                  <span style="padding-left: 10px">个</span>
                </div>
              </div>
              <div class="top-item">
                <div class="top-txt">光地展位<span class="top-txt2">（18㎡起订）</span>/Standard booth<span class="top-txt2">(MOQ: 18m)</span>
                  <!-- <span class="top-txt2">（18㎡起订）</span> -->
                </div>
                <div>
                  <Radio label="光地"></Radio>
                  <InputNumber :max="99999" :min="1" v-model="showArea" :disabled="areaType !== '光地'" style="width:140px;"></InputNumber>
                  <span style="padding-left: 10px">㎡</span>
                </div>
              </div>
            </RadioGroup>
            <Checkbox v-model="isNeedActivity">我公司需要在现场做广告宣传、参加会议活动
            <p style="margin-left: 1.5em;">We need to advertise and participate in conferences</p></Checkbox>
          </div>
          <div class="bottom">
            <div class="box">
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col flex="auto" span="15">展位分类 / Booth type
                  </Col>
                  <Col span="7" flex="auto">价格 / Price
                  </Col>
                  <!-- <Col span="8">早鸟价格<br />
                  （3月31日前）
                  </Col> -->
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">光地展位一类 / Raw space type I
                  </Col>
                  <Col span="7">11448RMB / 9㎡
                  </Col>
                  <!-- <Col span="8">1,200元 / ㎡
                  </Col> -->
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">光地展位二类 / Raw space type II
                  </Col>
                  <Col span="7">9328RMB / 9㎡
                  </Col>
                  <!-- <Col span="8">1,000元 / ㎡
                  </Col> -->
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">光地展位三类 / Raw space type III
                  </Col>
                  <Col span="7">7420RMB / 9㎡
                  </Col>
                  <!-- <Col span="8">12,500元 / 9㎡
                  </Col> -->
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">标准展位一类 / Standard booth type I
                  </Col>
                  <Col span="7">12720RMB / 个
                  </Col>
                  <!-- <Col span="8">11,250元 / 9㎡
                  </Col> -->
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">标准展位二类 / Standard booth type II
                  </Col>
                  <Col span="7">10070RMB / 个
                  </Col>
                </Row>
                <Row class="line" type="flex" justify="center" align="middle">
                  <Col span="15">标准展位三类 / Standard booth type III
                  </Col>
                  <Col span="7">8162RMB / 个
                  </Col>
                </Row>
              </div>
            <!-- <div class="tip">
              <div class="dot">协会会员单位可以享有价格9折的优惠；</div>
              <div class="dot">18平米以下请选择标准展位，标准展位价格含标准搭建（地毯、照明射灯、电源、洽谈桌椅和问询台、楣板）；</div>
              <div class="dot">双面开口的标准展位需另付角位费：1000元/角</div>
            </div> -->
          </div>
        </div>
      </div>
      <div class="gap"></div>
      <div class="select-box">
        <div class="top-title2">
          <div class="line"></div>
          选择您的展位范围 / Select your booth range
        </div>
        <div class="select-content">
          <div class="selectbox">
            <Tree :data="arr" show-checkbox check-directly @on-check-change="onSelectChange"></Tree>
            <!-- <div class="other">
              <Checkbox label="其他（注明）">其他（注明）<Input v-model="other2" style="width: 100px;" class="under-btn" /></Checkbox>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  props: {},
  data () {
    return {
      company1: '',
      isNeedActivity: false,
      productName: '',
      areaName: [],
      other2: '',
    //   areaType: '',
    //   showArea: null,
    areaType: '光地',
      showArea: '',
      hallCount: null,
      arr: [
        {
          title: '仪器 /  Instruments',
          expand: true,
          children: [
            { title: '分析仪器 / Analytical instruments' },
            { title: '实验室常用设备 / Conventional lab' },
            { title: '物理测试仪器及设备 / Physical test instruments and devices' },
            { title: '光学仪器及设备 / Optical instrument' },
            { title: '测量、计量仪器 / Measuring and metering instruments' },
            { title: '行业专用仪器 / Industry-specific instruments' },
            { title: '生命科学仪器 / Life science instruments' },
            { title: '在线及控制仪器 / On-line and control instruments' },
            { title: '仪表 / Meters' },
          
          ]
        },
        {
          title: '试剂 / Reagents', expand: false,
          children: [
            { title: '化学试剂 / Chemical reagents' },
            { title: '生化试剂 / Biochemical reagents' },
            { title: '标准物质 / Reference materials' },
          ]
        },
        {
          title: '耗材 / Consumables', expand: false,
          children: [
            { title: '仪器专用配件 / Instrument-specific accessories' },
            { title: '通用配件 / General accessories' },
            { title: '实验室常用耗材 / Conventional laboratory consumables' },
          ]
        },
        {
          title: '实验室基础设施及软技术 / Laboratory infrastructure and soft technology', expand: false,
          children: [
            { title: '实验室基础设施 / Laboratory infrastructure' },
            { title: '软技术 / Soft technology' },
          ]
        },
      ]
    };
  },
  methods: {
    ...mapActions({
      getExhibitionById: 'registerdModule/getExhibitionById',
    }),
    async getExhibitionHandle () {
      let res = await this.getExhibitionById('12395618-C8B3-45C1-8216-D7A87407B884');
      if (res) {
        this.company1 = res;
        console.log('getExhibitionHandle', this.company1);
      }
    },
    async validHandle () {
        console.log(this.areaName,'areaName');
            if(!this.areaName||this.areaName.length<=0){
                this.$Message.error("请选择您的展位范围");
                    return Promise.resolve({ valid: false });
            }
      if (this.areaType) {
        if (this.areaType === '光地'  && this.showArea < 18) {
          this.$Message.error("请输入光地展位的面积(18㎡起订)");
          return Promise.resolve({ valid: false });
        }
        if (this.areaType === '标摊'  && !this.hallCount) {
          this.$Message.error("请输入标准展位的个数");
          return Promise.resolve({ valid: false });
        }
      } else {
        this.$Message.error("请选择您预定的展位");
        return Promise.resolve({ valid: false });
      }
      if (this.other2) {
        this.areaName.map((c, index) => {
          if (c === '其他（注明）') {
            this.areaName[index] = c + ':' + this.other2;
          }
        });
      }
      let showArea = this.showArea;
      if (this.areaType === '标摊') {
        showArea = this.hallCount * 9;
      }
      let res = {
        exhibition: [this.company1],
        ApplyCompanyOrder: {
          isNeedActivity: this.isNeedActivity,
          areaType: this.areaType,
          hallCount: this.hallCount || 0,
          showArea: showArea,
          areaName: this.areaName.join(';'),
        }
      }
      return Promise.resolve({ valid: true, ...res });
    },
    change1 (e) {
      this.showArea = null;
      this.hallCount = null;
    },
    onSelectChange (e) {
      let arr = []
      e.forEach(e => {
        arr.push(e.title);
      });
      this.areaName = arr;
      console.log('areaName', this.areaName);
    }
  },
  created () {
    this.getExhibitionHandle();
  },
}


</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #00a0e9 !important;
    }
    .ivu-radio-inner:after {
      background-color: #00a0e9;
    }
    .ivu-switch-checked {
      border-color: #00a0e9;
      background-color: #00a0e9;
    }
  }
  &-header {
    width: 100%;
    height: 50px;
    background-color: #00a0e9;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 50px;
      font-size: 15px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
  &-title {
    line-height: 48px;
    font-size: 18px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;
    span {
      font-size: 12px;
    }
  }
}
.choice {
  margin-bottom: 30px;
}
.choicebox {
  min-height: 686px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  &.active {
    background-color: #fdf7f9;
    border: solid 1px #00a0e9;
    .select {
      opacity: 1;
    }
    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }
    .choicebox-tool {
      background-color: #f5eff1;
    }
  }
  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #00a0e9;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #00a0e9;
    font-size: 12px;
    color: #fff;
  }
  &-top {
    padding: 30px 30px 20px;
    .txt1 {
      font-size: 15px;
      color: #333;
      font-weight: 500;
      margin-bottom: 10px;
    }
    .txt2 {
      font-size: 12px;
      color: #666;
      margin-bottom: 8px;
    }
  }
  &-content {
    padding: 15px;
    .title {
      text-align: center;
      font-size: 15px;
      color: #333;
      margin-bottom: 20px;
    }
    .item {
      display: flex;
      align-items: center;
      flex: 1;
      &-box {
        width: 50%;
      }
      &-box2 {
        width: 50%;
        p {
          font-size: 12px;
          color: #333;
          font-weight: normal;
        }
      }
    }
    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    display: flex;
    align-items: center;
  }
}
.select-box {
  .select-title {
    line-height: 48px;
    background-color: #f2f2f2;
    padding-left: 31px;
    font-size: 18px;
  }
}
.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -2px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;
      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}
.select-content-title {
  font-size: 15px;
  color: #333;
  margin-bottom: 18px;
}
.top {
  padding: 15px;
  color: #333;
  border-bottom: 1px solid #e6e6e6;
  &-txt {
    font-size: 12px;
    padding-left: 20px;
    padding-bottom: 10px;
  }
  &-txt2 {
    color: #999;
  }
  &-title {
    font-size: 15px;
    margin-bottom: 28px;
  }
  &-item {
    margin-bottom: 26px;
  }
}
.bottom {
  padding: 15px;
}
.box {
  text-align: center;
  .line {
    height: 42px;
    font-size: 12px;
    color: #333;
    &:first-child {
      font-size: 12px;
      color: #fff;
      background-color: #00a0e9 !important;
      .ivu-col {
        border-right: 1px solid #fff;
      }
    }
    &:nth-child(odd) {
      background-color: #f2fafe;
    }
    &:nth-child(even) {
      background-color: #fff;
    }
    .ivu-col {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #d9f3ff;
      &:last-child {
        border-color: transparent !important;
      }
    }
  }
}
.tip {
  margin-top: 30px;
  font-size: 10px;
  color: #666;
}
.dot {
  position: relative;
  padding-left: 10px;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: #999;
    border-radius: 50%;
    top: 10px;
    margin-top: -2px;
  }
}
.last {
  margin-bottom: 0 !important;
}
.top-title2 {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 15px;
  color: #333;
  font-weight: 600;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  &.s-noline {
    border-bottom: none;
  }
  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #00a0e9;
    margin-right: 7px;
  }
  span {
    font-size: 15px;
    .upload-btn2 {
      width: 105px;
      height: 105px;
      border: dotted 1px #bfbfbf;
      text-align: center;
      margin: 10px 15px;
      border-radius: 4px;
      position: relative;
      margin-left: 10px;
      img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
      }
    }
    color: #f00;
  }
  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
.selectbox {
  margin: 15px;
  background-color: #fff;
  border-radius: 3px;
  overflow: hidden;
  border: solid 1px #e5e5e5; 
  .other {
    line-height: 40px;
    width: 100%;
    padding-left: 14px;
    input {
      background: transparent;
    }
  }
  ::v-deep {
    .ivu-tree {
      > ul {
        padding-top: 2px;
        padding-bottom: 2px;
        border-bottom: solid 1px #e5e5e5;
        position: relative;
        padding-left: 10px;
        &:last-child {
          boder-bottom: none;
        }
      }
      .ivu-tree-arrow {
        position: absolute;
        right: 10px;
        top: 20px;
        margin-top: -10px;
      }
      .ivu-tree-arrow i {
        color: #999;
      }
    }
  }
}
.gap {
  height: 15px;
  background: #f7f7f7;
  width: 100%;
}
 /deep/ .ivu-tree ul li{
    
}
 /deep/ .ivu-checkbox-wrapper + span, .ivu-checkbox + span{
    white-space: break-spaces;
    width: 90%;
}
</style>
